import { ICheckPaymentByProviderResponseError } from '../../../../repositories/billing-payments/v1/check-payment-by-provider';
import { EPaymentStatus } from '../../../../types/reducers/depositAccount';
import { IPaymentStatus } from '../types';

export const mapResponse400 = (response: ICheckPaymentByProviderResponseError): IPaymentStatus => {
  const { message } = response;

  return { status: EPaymentStatus.Pending, message };
};
